module.exports = __webpack_public_path__ + "media/empty-states/attendees-6597d74c.png";